__turbopack_context__.v({
  "root": "style-module-scss-module__6su6Wq__root",
});
